import { useCallback, useEffect, useRef, useState } from 'react';
import AnimateHeight from 'react-animate-height';
export function AnimateExpand({
  isExpanded,
  children
}) {
  const [height, setHeight] = useState(isExpanded ? 'auto' : 0);
  const contentRef = useRef(null);
  const [shouldRender, setShouldRender] = useState(isExpanded);
  useEffect(() => {
    if (isExpanded) {
      setShouldRender(true);
    } else {
      setHeight(0);
    }
  }, [isExpanded]);
  useEffect(() => {
    const element = contentRef.current;
    if (element && isExpanded) {
      const resizeObserver = new ResizeObserver(() => {
        setHeight(element.offsetHeight);
      });
      resizeObserver.observe(element);
      return () => {
        resizeObserver.disconnect();
      };
    }
  }, [shouldRender, isExpanded]);
  const onHeightAnimationEnd = useCallback(newHeight => {
    if (newHeight === 0 && !isExpanded) {
      setShouldRender(false);
    }
  }, [isExpanded]);
  return <AnimateHeight duration={500} height={height} disableDisplayNone onHeightAnimationEnd={onHeightAnimationEnd}>
			{shouldRender ? children(contentRef) : null}
		</AnimateHeight>;
}